import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import { Box } from '@mui/material';
import { InventoryProvider } from '../../contexts/InventoryContext';

import ProjectsPage from './ProjectsPage';
import { Developers } from './developers/DevelopersBase';
import { ProjectDetail } from './projects/project_details/ProjectDetailsBase';
import ProjectMasterView from './projects/ProjectMasterView';
import { ConfigDetail } from './config_details';
import { UnitDetail } from './projects';

/**
 * Inventory hub (like ReportBase). Defines all inner routes under /inventory.
 * App.js uses: <Route path="inventory/*" element={<InventoryBase />} />
 */
const InventoryBase = () => (
  <InventoryProvider>
    <Box
      sx={{
        flexGrow: 1,
        width: '100%',
        minHeight: 0,
        display: 'flex',
        flexDirection: 'column',
      }}
    >
      <Routes>
        <Route path="/" element={<Navigate to="/inventory/projects" replace />} />
        <Route path="projects" element={<ProjectsPage />} />
        <Route path="developers" element={<Developers />} />
        <Route path="projects/:projectId" element={<ProjectMasterView />} />
        <Route path="projects/:projectId/details" element={<ProjectDetail />} />
        <Route path="projects/:projectId/configurations" element={<ProjectDetail defaultTab="configurations" />} />
        <Route path="projects/:projectId/configurations/:configurationId" element={<ConfigDetail />} />
        <Route path="projects/:projectId/configurations/:configurationId/units/:unitId" element={<UnitDetail />} />
      </Routes>
    </Box>
  </InventoryProvider>
);

export default InventoryBase;
